<template>
  <!-- Desktop -->
  <Modal 
    :title            = "featureData.panelTitle"
    v-model:showModal = "productChanging"
    ref="changeProductModal"
  >
    <template #body>
      <!-- proudct page -->
      <div v-if="showProductPage">
        <ProductPage 
          :productSlug     = "currentProductSlug"
          @onChangeProduct = "changeProduct"
          @onClickBack     = "back"
        >
        </ProductPage>         
      </div>

      <div v-else class="h-100">
        <!-- hot product -->
        <div v-if="!showMoreMode" class="h-100 d-flex flex-column justify-content-center">
          <div class="text-center mk-fsize-18">
            添加您喜愛的商品，並開始您的設計。
          </div>

          <ProductList 
            :products       = "categoryProducts"
            keyPrefix       = "hot"
            productStyle    = "width:170px"
            @onProductClick = "goToProductPage"
            class           = "align-items-center justify-content-center flex-grow-1"
          ></ProductList>

          <div class="d-flex justify-content-end pb-4 pe-4">
            <button class="mk-btn" @click ="firstLoadCategoryProducts">
              更多商品
            </button>
          </div>
        </div>

        <!-- all product list -->
        <div v-else class="mk-resource__container h-100">
          <div class="mk-resource__menu">
            <h1>所有分類</h1>
            
            <!-- menu -->
            <div class="mk-resource__menu-content">
              <div
                class  = "mk-resource__menu-item"
                v-for  = "category in productCategories"
                :key   = "category.slug"
                @click = "changeCategory(category)"
              >
                <div :class="currentProductCategorySlug == category.slug ? 'mk-resource__menu-item--active': ''">
                  {{ category.name }}
                </div>
              </div>
            </div>
          </div>       

          <div class="mk-resource__right">
            <div class="mk-resource__action">
              <input class="search-input" v-model="productSearch" type="text" placeholder="搜尋產品或產品型號">
            </div>

            <!-- mini menu -->
            <div class="mk-resource__mini-menu">
              <div
                class  = "mk-resource__mini-menu-item"
                v-for  = "category in productCategories"
                :key   = "category.slug"
                @click = "changeCategory(category)"
                :class="currentProductCategorySlug == category.slug ? 'mk-resource__mini-menu-item--active': ''"
              >
                {{ category.name }}
              </div>
            </div>

            <ProductList 
              :products       = "filterProducts"
              keyPrefix       = "general"
              @onProductClick = "goToProductPage"
            ></ProductList>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup>
  import ProductPage from "./product_page.vue"
  import ProductList from "./product_list.vue"
  import Modal from './Modal.vue'
  import {computed, onMounted, ref, watch, nextTick} from 'vue';
  import {featureData, isMobile, setFeatureData} from "~/vues/utils/feature.js"
  import {useDesignLabStore} from "../components/DesignLabStore.js"
  import {storeToRefs} from 'pinia'

  const designLabStore = useDesignLabStore();

  const {
    productCategories,
    categoryProducts,
    currentProductCategorySlug,
    productChanging,
    productSearch,
    hotProductCategorySlug,
  } = storeToRefs(designLabStore);

  const showMoreMode       = ref(false);
  const showProductPage    = ref(false);
  const currentProductSlug = ref("");
  const changeProductModal = ref(null);

  let generalLoaded = false;

  const setScollTop = () => {
    if(changeProductModal.value.$el) {
      changeProductModal.value.$el.querySelector('.modal-content').scrollTo(0,0)  
    }
  }

  const changeCategory = async (category) => {
    currentProductCategorySlug.value = category.slug;
    productSearch.value = "";
    await designLabStore.getCategroyProducts(category.slug);
  }

  const filterProducts = computed(() => {
    if(productSearch.value == "") {
      return categoryProducts.value;
    }

    return categoryProducts.value.filter((e)=>{
      return e.name.toLowerCase().match(productSearch.value.toLowerCase()) || 
             e.sku.toLowerCase().match(productSearch.value.toLowerCase())
    });
  });

  watch(productChanging, (n) => {
    if(!n) {
      setFeatureData('featureId', NaN)
    }
  });

  watch(isMobile, async (n) => {
    if(n && !showMoreMode.value) {
      firstLoadCategoryProducts();
    } 
  });

  const changeProduct = async (variantGroupID) => {
    setFeatureData('featureId', NaN);
    designLabStore.setDesignLabLoading(true);
    await designLabStore.changeProduct(variantGroupID);
  }

  const back = ()=>{
    showProductPage.value = false;
    currentProductSlug.value = null;
  }

  const goToProductPage = (slug)=>{
    showProductPage.value = true;
    currentProductSlug.value = slug;
    setScollTop();
  }

  const firstLoadCategoryProducts = ()=>{
    showMoreMode.value = true;

    if(!generalLoaded) {
      currentProductCategorySlug.value = productCategories.value[0]?.slug;
      designLabStore.getCategroyProducts(currentProductCategorySlug.value);
      generalLoaded = true;
    }
  }

  onMounted(async () => {
    if(isMobile.value) {
      firstLoadCategoryProducts();
    } else {
      currentProductCategorySlug.value = hotProductCategorySlug.value;
      await designLabStore.getCategroyProducts(currentProductCategorySlug.value);
    }

    nextTick(() => {
      productChanging.value = true;
    })
  });
</script>

<style scoped>
  .mk-btn {
    letter-spacing: 0.5rem;
  }

  .search-input {
    width: 100%;
    text-align: start;
    border: #cbc9c9 1px solid;

    &::placeholder {
      text-align: left;
      color: #cbc9c9; 
    }

    &:focus-visible {
      outline: #d1d1d1 1px solid;
    }
  }
</style>